module.exports = __webpack_public_path__ + "h5/img/funv-nav1.2b66a85c.png";